export default __webpack_public_path__ + "static/media/Festrahmenfenster B.e111d7c1.jpg";